module.exports = __webpack_public_path__ + "static/img/help5.ecb1ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/help5.png
// module id = k8kP
// module chunks = 1